const Config = {
  API_URL: import.meta.env.VITE_API_URL,
};

export default Config;
